import { useState } from "react";
import { useTranslation } from "react-i18next";
import { faqItems } from "@/mocks/landing";

export default function FAQ() {
  const { t } = useTranslation();
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center">
          <span className="inline-block text-xs font-semibold uppercase tracking-[0.2em] text-primary-600">
            {t("home.faq.eyebrow")}
          </span>
          <h2 className="mt-3 text-3xl md:text-4xl font-bold text-foreground-950">
            {t("home.faq.title")}
          </h2>
        </div>

        <div className="mt-12 space-y-4">
          {faqItems.map((item, i) => {
            const isOpen = open === i;
            return (
              <div
                key={item.questionKey}
                className="bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden transition-colors"
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? null : i)}
                  className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left cursor-pointer"
                >
                  <span className="font-semibold text-foreground-950">{t(item.questionKey)}</span>
                  <span
                    className={`shrink-0 w-8 h-8 flex items-center justify-center rounded-full bg-primary-50 text-primary-600 transition-transform ${
                      isOpen ? "rotate-45" : ""
                    }`}
                  >
                    <i className="ri-add-line text-lg"></i>
                  </span>
                </button>
                <div
                  className="grid transition-all duration-300 ease-in-out"
                  style={{ gridTemplateRows: isOpen ? "1fr" : "0fr" }}
                >
                  <div className="overflow-hidden">
                    <p className="px-6 pb-5 text-sm leading-relaxed text-foreground-600">{t(item.answerKey)}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}